import { notification } from "antd";
import getState, { cleanString, createPromise, dynamicSort } from "../utils/MainHelper";
import { getAllKeywordsInFolder, getAllKeywordsInFolderObject, getBrandGenericsHcp, getCountryCode, getCountryHardCodePackage, getMarketPackage, getMasterSize, getModuleCode, getPackage, getPackageObj, getSelectedAnalysis, getServer, getTranslation } from "../utils/oneintelligence/OneIntelligenceHelper";
import MainServices from "./Main.services";
import { setMasterSize, setWhitespaceObj } from "../store/components/Reports.slice";
import OneIntelligenceServices from "./OneIntelligence.services";
import store from "../store/store";
import WorkerServices from "./Worker.services";
import ConfigServices from "./Config.services";
import TreeServices from "./Tree.services";
import TrackFeatureServices from "./TrackFeature.services";
import ReportsServices from "./Reports.services";
import WhiteSpaceCacheServices from "./WhiteSpaceCache.services";

class WhiteSpaceServices {
    constructor() {
        this.cls = process.env.REACT_APP_OI_API_CLASS || "oneintel";
        this.whitespaceConfig = {};
        this.didGetConfig = false;
        this.whitespaceTranslatin = [];
        this.didGetTranslation = false;

        this.competitorCached = {}
    }

    findItemInTree(deepdiveobj) {
        const state = getState();
        const { currentWhitespaceTree } = state.reports;
        let found = null;
        function findNode(nodeArray) {
            nodeArray.forEach((node) => {
                if (node.path === deepdiveobj.path) {
                    found = node;
                } else if (node.children?.length) {
                    findNode(node.children);
                }
            });
        }
        findNode(currentWhitespaceTree);
        return found
    }

    getDeepDiveData(deepdiveobj, isCompetitor) {
        const found = this.findItemInTree(deepdiveobj)
        return WorkerServices.getWhiteSpaceCache([[found], isCompetitor]).then((resp) => {
            const [r] = resp;
            return r;
        });
    }

    getDeepDiveDataWithName(name, isCompetitor) {
        const findItemInTree = () => {
            const state = getState();
            const { currentWhitespaceTree } = state.reports;
            let found = null;
            function findNode(nodeArray) {
                nodeArray.forEach((node) => {
                    if (node.name === name) {
                        found = node;
                    } else if (node.children?.length) {
                        findNode(node.children);
                    }
                });
            }
            findNode(currentWhitespaceTree);
            return found
        }
        const found = findItemInTree()
        return WorkerServices.getWhiteSpaceCache([[found], isCompetitor]).then((resp) => {
            const [r] = resp;
            return r;
        });
    }

    getSSPAudienceSizeForWhiteSpace(monitorObj, givenMasterObj) {
        const { dispatch } = store;
        const { buildedTargets } = getState("marketExplorer").configuration;
        const { server } = getServer();
        const region = getCountryCode("savant");
        const options = {
            gateway: {
                class: this.cls,
                function: "sspgetaudiencesize"
            }
        };
        const mastersObj = givenMasterObj || buildedTargets[0].groups.reduce((acc, bigAnd) => {
            acc[bigAnd.code] = {};
            bigAnd.targets.forEach((item) => {
                const keyword = item.name.toLocaleLowerCase();
                if (!acc[bigAnd.code][keyword]) acc[bigAnd.code][keyword] = [keyword];
                getAllKeywordsInFolder(item.children || item.tempChildren).forEach((child) => {
                    if (!acc[bigAnd.code][keyword].includes(child)) {
                        acc[bigAnd.code][keyword].push(child);
                    }
                });
            });
            return acc;
        }, {});

        const getSSPAudienceSize = async (requestBody) => {
            const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
            const url = MainServices.url + "oneintel/" + options.gateway.function.toLocaleLowerCase()
            const newRequestResponse = getNewRequestResponse();
            const toMonitorParams = {
                ...monitorObj,
                ...newRequestResponse,
                url
            }
            startMonitor(requestBody, toMonitorParams)
            // return MainServices.savantApiCall(
            //     options.gateway.function,
            //     {
            //         ...requestBody,
            //         _class: "oneintel",
            //         _function: "sspgetaudiencesize",
            //     },
            //     options,
            //     server,
            //     url
            // ).promise.then((resp) => {
            //     endMonitor(resp, toMonitorParams)
            //     return resp
            // })
            return MainServices.smartApiCall(
                options,
                {
                    ...requestBody,
                    _class: "oneintel",
                    _function: "sspgetaudiencesize",
                }
            ).promise.then((resp) => {
                endMonitor(resp, toMonitorParams)
                return resp
            })
        }
        const promises = Object.values(mastersObj).map((items) => Promise.all(Object.values(items).map((kws) => {
            const audienceItems = kws.map((text) => {
                const newText = text.split(" ").join(" ")
                return newText
            });

            if (audienceItems.length === 1) audienceItems.push("the heck")

            return getSSPAudienceSize({
                region,
                type: "keyword",
                items: audienceItems,
                server
            }).then((resp) => {
                const { data } = resp || {};
                if (!data) { return 0; }
                return Object.keys(data).reduce((acc, key) => {
                    const value = data[key];
                    acc += value;
                    return acc;
                }, 0);
            })
        })).then((resp) => resp.reduce((sum, folderVal) => {
            sum += folderVal;
            return sum;
        }, 0)));

        return Promise.all(promises).then((resp) => {
            const newMasterVal = Math.min(...resp)
            if (!givenMasterObj) {
                dispatch(setMasterSize(newMasterVal));
            }
            return newMasterVal
        });
    }

    getUsigMatrix(masters, selections) {
        const { server } = getServer();
        const options = {
            gateway: {
                class: this.cls,
                function: "getusigmatrix"
            }
        };
        const { promise } = MainServices.smartApiCall(
            options,
            {
                region: getCountryCode("savant"),
                subjectsLimit: 50,
                columnWindow: 2,
                rowWindow: 20,
                randomBaseline: 0.0400,
                normalizeByMaster: true,
                type: "keyword",
                masters,
                selections,
                server
            }, () => { }
        );
        return promise;
    }

    async getWhiteSpaceUsigMatrix() {
        const {
            hcps,
            brands,
            mokbs,
            generics
        } = getBrandGenericsHcp();

        const newGenerics = Object.keys(hcps).length ? hcps : generics;
        const newBrands = Object.keys(brands).length ? brands : mokbs;

        return this.getUsigMatrix(Object.keys(newGenerics).reduce((acc, key) => {
            const newKey = getTranslation(key);
            acc[newKey] = newGenerics[key].map((i) => getTranslation(i.key));
            return acc;
        }, {}), Object.values(newBrands).reduce((acc, arr) => {
            arr.forEach((i) => {
                acc[getTranslation(i.key)] = [getTranslation(i.key)];
            });
            return acc;
        }, {})).then((resp) => {
            if (!resp) return {};
            if (resp?.countryloading) return {};
            return resp.data;
        });
    }

    async getWhiteSpace(monitorObj) {
        const { dispatch } = store;
        const { checkedWhiteSpaceSelections, currentWhitespaceTree, generateGrid } = getState("reports");
        const {
            hcpsOrigText,
            brandsOrigText,
            genericsOrigText,
            hcps,
            brands,
            mokbs,
            generics
        } = getBrandGenericsHcp();
        const newBrands = Object.keys(brands).length ? brands : mokbs;

        const whitespaceObj = {
            hcps: Object.keys(hcps).reduce((acc, key) => {
                acc[key] = hcps[key].map((i) => i.key);
                return acc;
            }, {}),
            brands: Object.values(newBrands).reduce((acc, arr) => {
                arr.forEach((i) => {
                    acc[i.key] = [i.key];
                });
                return acc;
            }, {}),
            generics: Object.values(generics).reduce((acc, arr) => {
                arr.forEach((i) => {
                    acc[i.key] = [i.key];
                });
                return acc;
            }, {})
        };

        dispatch(setWhitespaceObj(whitespaceObj));

        const packageValue = getCountryHardCodePackage() || getPackage();
        const { server } = getServer();

        const getRequestObj = (selectionObj) => ({
            generics: Object.keys(whitespaceObj.hcps).length ? whitespaceObj.hcps : whitespaceObj.generics,
            brands: whitespaceObj.brands,
            targets: {},
            region: getCountryCode("savant"),
            op: "ave",
            type: "keyword",
            limit: 100,
            selections: selectionObj,
            generateCache: true,
            useCache: true,
            server,
            country: getCountryCode(2),
            enterpriseCode: getCountryCode("enterprise"),
            package: packageValue,
            marketPackage: getMarketPackage(),
            masterOrSelection: packageValue,
        });

        const addDataInSelection = (list) => {
            const selections = {};
            list.forEach((item) => {
                const childName = item.name.toLocaleLowerCase();
                const childList = item.children || item.tempChildren;
                selections[childName] = childList ? getAllKeywordsInFolder(childList, selections[childName] || []) : [childName];
            });
            return selections;
        };
        const getAllLastItemWithChildren = (list) => {
            const withChildren = [];
            const recursiveToGetLastItemWithChidren = (items) => {
                items.forEach((item) => {
                    if (item.children) {
                        const [firstChild] = item.children;
                        if (firstChild.children) {
                            recursiveToGetLastItemWithChidren(item.children);
                        } else if (firstChild.lvl === 2 && firstChild.tempChildren) {
                            recursiveToGetLastItemWithChidren(item.children);
                        } else {
                            withChildren.push(item);
                        }
                    } else if (item.lvl === 2) {
                        withChildren.push(item);
                    }
                });
            };
            recursiveToGetLastItemWithChidren(list);
            return withChildren;
        };

        const options = {
            gateway: {
                class: this.cls,
                function: "getwhitespace"
            }
        };
        const sendApiCallGetWS = async (requestObj, selectionList, categName) => {
            const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
            const newRequestResponse = getNewRequestResponse();
            const toMonitorParams = {
                ...monitorObj,
                ...newRequestResponse,
            }
            const monitorCallBack = (sqsUrl, request) => {
                toMonitorParams.url = sqsUrl + "/getwhitespace"
                startMonitor(request, toMonitorParams);
            }
            //NOTE: jehu
            return WhiteSpaceCacheServices.initScan(requestObj, categName).then(async (cacheStoreRes) => {
                const handleRes = async (res) => {
                    const generics = Object.keys(hcpsOrigText).length ? hcpsOrigText : genericsOrigText;
                    return WorkerServices.parseWhitespaceReponse([res, whitespaceObj, {
                        selections: selectionList,
                        brands: brandsOrigText,
                        generics
                    }])
                        .then((parsedData) => parsedData.reduce((acc, cat) => {
                            (cat.children || []).forEach((d) => {
                                const newDiff = d.diff === null || isNaN(d.diff) ? 0 : d.diff;
                                acc.push({
                                    ...d,
                                    brandSpace: (1 - newDiff) * 100,
                                    diff: (newDiff) * 100
                                });
                            });
                            return acc;
                        }, []));
                }
                const { cached, resData } = cacheStoreRes;
                if (cached && resData) {
                    return handleRes(resData)
                } else {
                    return await MainServices.smartApiCall(options, requestObj, () => { }, monitorCallBack).promise.then(async (res) => {
                        if (!res) return [];
                        if (res?.countryloading) {
                            return res;
                        }
                        if (res.data) {
                            return await WhiteSpaceCacheServices.cacheNewItem(requestObj, res.data, categName).then(async ({ isSuccess }) => {
                                return handleRes(res.data);
                            });
                        }
                        return [];
                    }).then((res) => {
                        endMonitor(res, toMonitorParams)
                        return res
                    })
                }
            })

        };
        const allFirstLevel = {};
        const newList = [...checkedWhiteSpaceSelections].sort(dynamicSort("lvl", true)).reduce((acc, item) => {
            if (!item.parentPath) {
                allFirstLevel[item.key] = item;
                acc.tempList.push(item);
                acc.checker.push(item.path);
            } else {
                const [firstLevelKey] = item.path.split("/");
                if (!allFirstLevel[firstLevelKey]) {
                    allFirstLevel[firstLevelKey] = currentWhitespaceTree.find((firstData) => firstData.key === firstLevelKey);
                }
                const found = acc.checker.find((key) => item.parentPath.includes(key));
                if (!found) {
                    acc.tempList.push(item);
                    acc.checker.push(item.path);
                }
            }
            return acc;
        }, {
            tempList: [],
            checker: []
        });

        const findIfExistingInReport = (tempItem) => {
            const found = generateGrid.find((item) => item.path === tempItem.path);
            if (found) {
                if (tempItem.children) {
                    const [firstChild] = tempItem.children;
                    if (firstChild.children) {
                        return tempItem.children.reduce((acc, child) => {
                            const existing = findIfExistingInReport(child);
                            existing.forEach((tItem) => {
                                acc.push(tItem);
                            });
                            return acc;
                        }, []);
                    }
                }
                return [];
            }
            return [tempItem];
        };

        let newListTodisplay = newList.tempList;
        newListTodisplay = newListTodisplay.reduce((acc, item) => {
            if (item.children) {
                const existing = findIfExistingInReport(item);
                existing.forEach((tItem) => {
                    acc.push(tItem);
                });
            } else {
                const found = acc.find((fItem) => fItem.key === item.parentKey);
                if (found) {
                    found.children.push(item);
                } else {
                    acc.push({
                        name: item.parent,
                        key: item.parentKey,
                        path: item.parentPath,
                        children: [item]
                    });
                }
            }
            return acc;
        }, []);

        const cached = await WorkerServices.getWhiteSpaceCache([newListTodisplay]);
        const hasnoCache = cached.find((cache) => cache.noCache);
        if (!hasnoCache && cached.length) {
            console.log("Cached");
            return cached;
        }

        const { promise, resolve } = createPromise();

        const allLastChildWithChildren = getAllLastItemWithChildren(Object.values(allFirstLevel));

        const notifObj = {
            message: "Generate Report Progress",
            description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
            duration: null,
            placement: "topRight",
            closable: true,
            // closeIcon: (<div />),
            key: "reportsnotif"
        };

        notification.info(notifObj);

        const numberOfCallInSameTime = 10
        const initialApiCall = numberOfCallInSameTime;
        let doneCallCount = 0;
        let lastIndex = 0;
        const prmList = allLastChildWithChildren.map(() => createPromise())


        const responses = [];
        const recursiveSendApiCall = (idx) => {
            const items = allLastChildWithChildren[idx];
            if (!items) {
                Promise.all(prmList.map((prm) => prm.promise)).then(() => resolve(responses))
                return
            }
            const tempList = (items.children || items.tempChildren) ? (items.children || items.tempChildren) : items;
            const categName = (items?.namePath || items?.path)?.split("/")[0].toLowerCase() || "Unknown";
            const requestObj = getRequestObj(addDataInSelection(tempList));
            const percent = (((idx + 1) / allLastChildWithChildren.length) * 90);

            notification.info({
                ...notifObj,
                description: <span style={{ color: "#52c41a" }}>
                    Please wait...(
                    {percent.toFixed(2)}
                    %)
                </span>
            });
            return sendApiCallGetWS(requestObj, tempList, categName).then(async (res) => {
                doneCallCount += 1
                responses.push(res);
                lastIndex += 1
                prmList[idx].resolve()
                recursiveSendApiCall(lastIndex);
            })
        };
        lastIndex = allLastChildWithChildren.length < initialApiCall ? allLastChildWithChildren.length - 1 : 4
        for (let index = 0; index < initialApiCall; index++) {
            recursiveSendApiCall(index);
        }

        return promise.then(async (resp) => {
            let loadingCountry = false;
            resp.forEach((itemResp) => {
                if (itemResp.countryloading) {
                    loadingCountry = true;
                }
            });
            if (loadingCountry) {
                return [];
            }
            const audienceList = await this.getCategoryAudienceSize(Object.values(allFirstLevel));
            notification.info({
                ...notifObj,
                description: <span style={{ color: "#52c41a" }}>
                    Please wait...(
                    {(100).toFixed(2)}
                    %)
                </span>
            });

            const analysis = getSelectedAnalysis();
            return WorkerServices.appendScoreToCategory([
                Object.values(allFirstLevel),
                resp, newListTodisplay,
                audienceList, getMasterSize(), undefined, { analysis, moduleCode: getModuleCode(), country: getCountryCode("enterprise") }]).then((result) => {
                    console.log(result);
                    return result;
                });
        });
    }


    async getWhiteSpaceCompetitors(competitorParams, clear) {
        const { dispatch } = store;

        const { buildedTargets } = getState("marketExplorer").configuration;
        const { checkedWhiteSpaceSelections, currentWhitespaceTree, baseline } = getState("reports");
        const { master, categories, categoriesList, categoriesArr, masterName } = competitorParams
        if (clear) {
            this.competitorCached = {}
        }
        if (this.competitorCached[masterName]) return Promise.resolve(this.competitorCached[masterName])
        const current = getSelectedAnalysis();
        let featureName = "Whitespace/Run " + current.name + " Competitors"
        const { commonParams } = TrackFeatureServices.getMonitor({ featureName })


        const getLevel3Data = () => {
            const level3Data = {};
            const foundInTree = categoriesList.map((obj) => this.findItemInTree(obj));
            const appendLevel3Data = (list) => {
                if (!list) return
                list.forEach((item) => {
                    const childName = item.name.toLocaleLowerCase();
                    const childList = item.children || item.tempChildren;

                    let isKeywords = item.lvl === 3
                    if (item.lvl === 2 && !childList) isKeywords = true
                    if (isKeywords) {
                        const keywords = childList ? getAllKeywordsInFolder(childList, []) : [childName]
                        level3Data[(item.namePath || item.path).toLocaleLowerCase()] = keywords;
                    } else {
                        appendLevel3Data(childList)
                    }
                });
            }
            appendLevel3Data(foundInTree);
            return level3Data
        }
        const newSelections = getLevel3Data();

        // const { server } = getServer();
        // const region = getCountryCode("savant");
        const sspAudience = await this.getSSPAudienceSizeForWhiteSpace(commonParams, {
            wp_medications: master
        })

        // const filterTree = categoriesArr || currentWhitespaceTree.filter((obj) => {
        //     if (categories.includes(obj.name)) return obj
        // })

        // const childObjectList = {};
        // const selections = {};
        // filterTree.forEach((item) => {
        //     const childName = item.name.toLocaleLowerCase();
        //     const childList = item.children || item.tempChildren;
        //     if (childList && childList.length) {
        //         childObjectList[childName] = childList;
        //     }
        //     selections[childName] = childList ? getAllKeywordsInFolder(childList, []) : [childName];
        //     // (childList ? getAllKeywordsInFolder(childList, []) : [childName]).forEach((text) => {
        //     //     selections[text] = [text]
        //     // });
        // });
        const getBatchedSelections = (givenSelection) => {
            const maxItemPerBatch = 40
            let currentIdx = 0
            return Object.keys(givenSelection).reduce((acc, key) => {
                if (Object.keys(acc[currentIdx] || {}).length === maxItemPerBatch) currentIdx += 1
                if (!acc[currentIdx]) acc[currentIdx] = {}
                acc[currentIdx][key] = givenSelection[key]
                return acc
            }, [])
        }

        const batchSelections = getBatchedSelections(newSelections)
        return Promise.all(batchSelections.map((batchedSelection) => {
            const requestObj = { selections: batchedSelection, masters: master, masterSize: sspAudience };
            const { promise } = ReportsServices.getUsigDeepDive(requestObj, undefined, commonParams);
            return promise
        })).then((batchResponse) => {
            let finalResponse = batchResponse.flat();
            finalResponse = finalResponse.length === 1 ? finalResponse[0] : finalResponse.reduce((acc, item, idx) => {
                if (!idx) return acc
                acc.children = acc.children.concat(item.children)
                return acc
            }, finalResponse[0])

            return WorkerServices.whitespaceDynamic("parseCompetitorResponse", [[finalResponse]]).then((parsed) => {
                this.competitorCached[masterName] = parsed
                return parsed
            })
        })
    }

    async getWhiteSpaceV2() {
        const { dispatch } = store;
        const { checkedWhiteSpaceSelections, currentWhitespaceTree, generateGrid } = getState("reports");

        const {
            hcpsOrigText,
            brandsOrigText,
            genericsOrigText,
            hcps,
            brands,
            generics
        } = getBrandGenericsHcp();

        const whitespaceObj = {
            hcps: Object.keys(hcps).reduce((acc, key) => {
                acc[key] = hcps[key].map((i) => i.key);
                return acc;
            }, {}),
            brands: Object.values(brands).reduce((acc, arr) => {
                arr.forEach((i) => {
                    acc[i.key] = [i.key];
                });
                return acc;
            }, {}),
            generics: Object.values(generics).reduce((acc, arr) => {
                arr.forEach((i) => {
                    acc[i.key] = [i.key];
                });
                return acc;
            }, {})
        };

        dispatch(setWhitespaceObj(whitespaceObj));

        const packageValue = getCountryHardCodePackage() || getPackage();
        const { server } = getServer();

        const getRequestObj = (selectionObj) => ({
            generics: Object.keys(whitespaceObj.hcps).length ? whitespaceObj.hcps : whitespaceObj.generics,
            brands: whitespaceObj.brands,
            targets: {},
            region: getCountryCode("savant"),
            op: "ave",
            type: "keyword",
            limit: 100,
            selections: selectionObj,
            generateCache: true,
            useCache: true,
            server,
            country: getCountryCode(2),
            enterpriseCode: getCountryCode("enterprise"),
            package: packageValue,
            marketPackage: getMarketPackage(),
            masterOrSelection: packageValue,
        });

        const addDataInSelection = (list) => {
            const selections = {};
            list.forEach((item) => {
                const childName = item.name.toLocaleLowerCase();
                const childList = item.children || item.tempChildren;
                selections[childName] = childList ? getAllKeywordsInFolder(childList, selections[childName] || []) : [childName];
            });
            return selections;
        };

        const options = {
            gateway: {
                class: this.cls,
                function: "getwhitespace"
            }
        };
        const sendApiCall = (requestObj, selectionList) => MainServices.smartApiCall(options, requestObj, () => { }).promise.then((resp) => {
            if (!resp) return [];
            if (resp?.countryloading) {
                return resp;
            }
            if (resp.data) {
                return WorkerServices.parseWhitespaceReponse([resp.data, whitespaceObj, {
                    selections: selectionList,
                    brands: brandsOrigText,
                    generics: Object.keys(hcpsOrigText).length ? hcpsOrigText : genericsOrigText
                }]).then((parsedData) => parsedData.reduce((acc, cat) => {
                    return acc.concat(cat.children);
                }, []));
            }
            return [];
        });
        const newList = checkedWhiteSpaceSelections.filter((item) => {
            if (!item.parentPath) return item;
        });

        let newListTodisplay = generateGrid.length ? newList.filter((newItem) => {
            const found = generateGrid.find((item) => item.path === newItem.path);
            if (!found) return newItem
        }) : newList

        const cached = await WorkerServices.getWhiteSpaceCache([newListTodisplay]);

        const hasnoCache = cached.find((cache) => cache.noCache);
        if (!hasnoCache && cached.length) {
            console.log("Cached");
            return cached;
        }

        const { promise, resolve } = createPromise();

        const notifObj = {
            message: "Generate Report Progress",
            description: <span style={{ color: "#52c41a" }}>Please wait...</span>,
            duration: null,
            placement: "topRight",
            closable: true,
            // closeIcon: (<div />),
            key: "reportsnotif"
        };
        notification.info(notifObj);
        sendApiCall(getRequestObj(addDataInSelection(newListTodisplay)), newListTodisplay).then((res) => {
            resolve(res);
        });

        return promise.then(async (resp) => {
            console.log(resp)
            let loadingCountry = false;
            resp.forEach((itemResp) => {
                if (itemResp.countryloading) {
                    loadingCountry = true;
                }
            });
            if (loadingCountry) {
                return [];
            }

            const audienceList = await this.getCategoryAudienceSizeV2(newListTodisplay);

            return WorkerServices.appendScoreToCategoryV2([resp, newListTodisplay, audienceList, getMasterSize()]).then((result) => {
                console.log(result);
                return result;
            });
        });
    }


    async getRelations(deepdiveobj, monitorObj) {
        const state = getState();
        const { url, server } = getServer();
        const {
            marketPackage
        } = state.buildTargets.setup;

        const found = this.findItemInTree(deepdiveobj)

        // get all keywords
        const keywords = [];
        const recursiveGetFolderAndKeywords = (list) => {
            if (!list) return;
            list.forEach((item) => {
                const childList = item.children || item.tempChildren;
                getAllKeywordsInFolderObject(childList, keywords);
                recursiveGetFolderAndKeywords(childList);
            });
        };
        recursiveGetFolderAndKeywords([found]);

        const [categoryPath] = deepdiveobj.path.split("/");
        // eslint-disable-next-line no-unused-vars
        const [catid, category] = categoryPath.split("~~");

        const cleanCategory = await this.getNewNameAfterWordRemoved(cleanString(category).toLocaleLowerCase());

        const getWithHightItemCount = () => {
            const { promise, resolve } = createPromise();
            const listOfItems = [...keywords.map((d) => cleanString(d.variants || d.key))];

            const recursiveCall = (idx) => {
                const currentText = listOfItems[idx];

                const options = {
                    gateway: {
                        class: this.cls,
                        function: "listrelationships"
                    }
                };

                const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
                const newRequestResponse = getNewRequestResponse();
                const toMonitorParams = {
                    ...monitorObj,
                    ...newRequestResponse,
                }
                const monitorCallBack = (sqsUrl, request) => {
                    toMonitorParams.url = sqsUrl + options.gateway.function
                    startMonitor(request, toMonitorParams);
                }
                MainServices.smartApiCall(options, {
                    type: "keyword",
                    region: getCountryCode("savant"),
                    limit: 1000,
                    tangentalThreshold: 0.2,
                    distantThreshold: 0.1,
                    precision: 0,
                    topic: "",
                    server,
                    items: [currentText, ...listOfItems]
                }, () => { },
                    monitorCallBack
                ).promise.then((resp) => {
                    if (!resp) return [];
                    if (resp?.countryloading) {
                        return resp;
                    }
                    if (resp?.status === "ERROR") {
                        console.log(resp);
                        return null;
                    }
                    if (!Object.keys(resp.data).length) {
                        recursiveCall(idx + 1);
                    } else {
                        const list = Object.keys(resp.data).reduce((acc, key) => {
                            // if (key !== cleanCategory) {
                            acc.push({
                                name: key,
                                itemCount: resp.data[key][1]
                            });
                            // }
                            return acc;
                        }, []);
                        const highestScore = Math.max(...list.map((d) => d.itemCount));
                        resolve(list.find((d) => highestScore === d.itemCount));
                    }
                }).then((res) => {
                    endMonitor(res, toMonitorParams)
                    return res
                })
            };
            recursiveCall(0);
            return promise;
        };

        const hightest = await getWithHightItemCount();

        const {
            brands,
            brands2ndChild,
            brandsOrigTextLower
        } = getBrandGenericsHcp();

        const cleanHightestName = cleanString(hightest.name).toLocaleLowerCase();

        const processToGetPieResult = async (brandList) => {
            const getRelationsips = async () => {
                const options = {
                    gateway: {
                        class: this.cls,
                        function: "listrelationships"
                    }
                };

                const { startMonitor, endMonitor, getNewRequestResponse } = TrackFeatureServices.getMonitor()
                const newRequestResponse = getNewRequestResponse();
                const toMonitorParams = {
                    ...monitorObj,
                    ...newRequestResponse,
                }
                const monitorCallBack = (sqsUrl, request) => {
                    toMonitorParams.url = sqsUrl + options.gateway.function
                    startMonitor(request, toMonitorParams);
                }
                const { promise } = MainServices.smartApiCall(options, {
                    type: "keyword",
                    region: getCountryCode("savant"),
                    server,
                    limit: 1000,
                    tangentalThreshold: 0.2,
                    distantThreshold: 0.1,
                    precision: 0,
                    topic: cleanHightestName,
                    items: [
                        cleanHightestName,
                        ...Object.values(brandList).reduce((acc, arr) => {
                            arr.forEach((i) => {
                                const nKw = i.variants || i.key;
                                if (!acc.includes(nKw)) acc.push(nKw);
                            });
                            return acc;
                        }, [])
                    ].map((text) => getTranslation(cleanString(text)))
                },
                    () => { },
                    monitorCallBack
                );
                return promise.then((resp) => {
                    if (!resp) return [];
                    if (resp?.countryloading) {
                        return resp;
                    }
                    if (resp?.status === "ERROR") {
                        console.log(resp);
                        return null;
                    }
                    return Object.keys(resp.data).reduce((acc, key) => {
                        acc[key] = ({
                            name: key,
                            relationshipCount: resp.data[key][2]
                        });
                        return acc;
                    }, {});
                }).then((resp) => {
                    endMonitor(resp, toMonitorParams)
                    return resp
                })
            };
            const relationlist = await getRelationsips();
            let foundName = null;
            function findNodeFromName(nodeArray) {
                nodeArray.forEach((node) => {
                    const childList = node.children || node.tempChildren;
                    const nodeName = getTranslation(cleanString(node.name.toLocaleLowerCase()));
                    if (nodeName === hightest.name.toLocaleLowerCase()) {
                        foundName = node;
                    } else if (node.variants === hightest.name) {
                        foundName = node;
                    } else if (childList?.length) {
                        findNodeFromName(childList);
                    }
                });
            }
            findNodeFromName(found.children || found.tempChildren);

            const matrix = await this.getWhiteSpaceUsigMatrix();

            const { list: listwithscore, sum: sumScoreBrands } = Object.values(brandList).reduce((acc, arr) => {
                arr.forEach((d) => {
                    const brandName = getTranslation(cleanString(d.variants || d.key));
                    let relationObj = relationlist[brandName] || relationlist[d.key];
                    let pieScore = relationObj.relationshipCount * deepdiveobj.avegenerics_raw;
                    const matrixObj = matrix[brandName] || matrix[d.key] || {};
                    if (matrixObj["[AVERAGE]"]) {
                        pieScore *= matrixObj["[AVERAGE]"];
                    }
                    if (!relationObj) {
                        relationObj = relationlist[brandName.replace(/[`']/g, "")];
                    }

                    const obj = {
                        name: d.name,
                        // origScore: deepdiveobj[`${d.key}_brands`],
                        avegenerics_raw: deepdiveobj.avegenerics_raw,
                        matrix: matrixObj["[AVERAGE]"],
                        pieScore,
                        relationScore: relationObj.relationshipCount
                    };
                    acc.list.push(obj);
                    acc.sum += obj.pieScore;
                });
                return acc;
            }, {
                list: [],
                sum: 0
            });

            const hasMarketGap = deepdiveobj.diff > 0;

            if (hasMarketGap) {
                listwithscore.unshift({
                    name: foundName.name,
                    isTopic: true,
                    origScore: deepdiveobj.diff,
                    pieScore: relationlist[getTranslation(hightest.name)].relationshipCount * (deepdiveobj.diff / 100),
                    relationScore: relationlist[getTranslation(hightest.name)].relationshipCount,
                    title: "Market Gap",
                    color: "#84D4D2",
                    score: deepdiveobj.diff
                });
            }

            const newList = Object.values(listwithscore.map((d) => {
                const tempObj = { ...d };
                if (!tempObj.title) {
                    tempObj.title = tempObj.name;
                }
                if (!tempObj.score) {
                    if (hasMarketGap) {
                        tempObj.score = ((d.pieScore / sumScoreBrands) * (1 - (deepdiveobj.diff / 100))) * 100;
                    } else {
                        tempObj.score = (d.pieScore / sumScoreBrands) * 100;
                    }
                }
                if (isNaN(tempObj.score)) tempObj.score = 0;
                return tempObj;
            }).reduce((acc, d) => {
                if (!acc[d.title]) {
                    acc[d.title] = d;
                } else {
                    acc[d.title].score += d.score;
                }
                return acc;
            }, {}));
            return Promise.resolve(newList.sort(dynamicSort("-score", true)));
        };

        let result = await processToGetPieResult(brands);
        if ((["jpn"].includes(getCountryCode("enterprise")) || marketPackage?.code?.replace("dev", "") === "healthcareclaims")
            && Object.keys(brands2ndChild).length) {
            const checker = Object.keys(brands2ndChild).reduce((acc, key) => {
                acc[key] = brands2ndChild[key].map((obj) => obj.name);
                return acc;
            }, {});
            result = result.reduce((acc, item) => {
                if (item.isTopic) {
                    acc[item.title] = item;
                } else {
                    const foundParent = Object.keys(checker).find((key) => checker[key].includes(item.title));
                    if (foundParent) {
                        const parentObj = brandsOrigTextLower[foundParent];
                        if (parentObj) {
                            if (!acc[parentObj.name]) {
                                acc[parentObj.name] = {
                                    title: parentObj.name,
                                    name: parentObj.name,
                                    score: item.score
                                };
                            } else {
                                acc[parentObj.name].score += item.score;
                            }
                        }
                    }
                }
                return acc;
            }, {});
            result = Object.values(result).sort(dynamicSort("-score", true));
        }

        if (marketPackage.code.replace("dev", "") === "healthcareclaims" && result.length > 10) {
            result = result.splice(0, 10);
        }


        const scoreSum = result.reduce((sum, item) => {
            if (!item.isTopic) {
                sum += item.score
            }
            return sum
        }, 0)
        if (!scoreSum) {
            console.log("safeguard")
            let isTopicObj = null
            const rawScore = result.reduce((acc, item) => {
                if (!item.isTopic) {
                    const key = Object.keys(deepdiveobj).find((key) => key.includes(item.name) && !key.includes("_ranked"));
                    if (key) {
                        acc.scores[item.name] = deepdiveobj[key] * 100
                        acc.sum += acc.scores[item.name]
                    }
                } else {
                    isTopicObj = item
                }
                return acc
            }, { scores: {}, sum: 0 })
            result = result.reduce((acc, item) => {
                if (rawScore.sum === 0) {
                    acc.push({
                        ...item,
                        score: 0
                    })
                } else {
                    if (!item.isTopic) {
                        let newScore = (rawScore.scores[item.name] / rawScore.sum) * 100;
                        newScore = isNaN(newScore) ? 0 : newScore;
                        acc.push({
                            ...item,
                            score: isTopicObj ? newScore * (1 - (isTopicObj.score / 100)) : newScore
                        })
                    } else {
                        acc.push(item)
                    }
                }
                return acc
            }, [])
        }

        return Promise.resolve(result);
    }

    async getCategoryAudienceSize(categories) {
        const { server } = getServer();
        const region = getCountryCode("savant");
        const options = {
            gateway: {
                class: this.cls,
                function: "sspgetaudiencesize"
            }
        };

        const getSSPAudienceSize = (requestBody) => MainServices.smartApiCall(
            options,
            {
                ...requestBody,
                _class: "oneintel",
                _function: "sspgetaudiencesize",
            }
        ).promise

        // MainServices.savantApiCall(
        //     options.gateway.function,
        //     {
        //         ...requestBody,
        //         _class: "oneintel",
        //         _function: "sspgetaudiencesize",
        //     },
        //     options,
        //     server,
        //     MainServices.url + "oneintel/" + options.gateway.function.toLocaleLowerCase()
        // ).promise;

        const getAudiencePerCategory = (category) => {
            const folderList = {};

            const recursiveGetFolderAndKeywords = (list) => {
                if (!list) return;
                list.forEach((item) => {
                    const keyword = item.name.toLocaleLowerCase();
                    const childList = item.children || item.tempChildren;
                    folderList[item.path] = childList?.length ? getAllKeywordsInFolder(childList, []) : [keyword];
                    recursiveGetFolderAndKeywords((!item.children && item.lvl === 2) ? item.tempChildren : item.children);
                });
            };
            recursiveGetFolderAndKeywords([category]);

            const audienceItems = Object.keys(Object.values(folderList).reduce((acc, arr) => {
                arr.forEach((t) => {
                    acc[t.split(" ").join(" ").toLocaleLowerCase()] = true
                })
                return acc;
            }, {}))
            if (audienceItems.length === 1) audienceItems.push("the heck")

            const requestObj = {
                region,
                type: "keyword",
                // items: Object.values(folderList)[0],
                items: audienceItems,
                server
            }
            const categName = category?.title?.toLowerCase();
            return WhiteSpaceCacheServices.initScan(requestObj, categName, "size").then(async (cacheStoreRes) => {
                const { cached, resData } = cacheStoreRes;
                // if (cached) {
                //     return WorkerServices.getAudienceSizeCache([resData, folderList])
                // } else {
                return getSSPAudienceSize(requestObj).then((resp) => {
                    const { data } = resp || {};
                    if (!data) { return {}; }
                    const audienceList = Object.keys(folderList).reduce((acc, path) => {
                        acc[path] = 0;
                        Object.keys(resp.data).forEach((key) => {
                            if (folderList[path].includes(key)) {
                                acc[path] += resp.data[key];
                            }
                        });
                        return acc;
                    }, {});
                    return WhiteSpaceCacheServices.cacheNewItem(requestObj, audienceList, categName, "size").then(async () => audienceList);
                });
                // }
            })
        };

        const finalObj = {};
        return Promise.all(categories.map((cat) => {
            return WorkerServices.getAudienceCache([cat]).then((cacheRes) => {
                if (cacheRes.noCache) return getAudiencePerCategory(cat)
                return cacheRes
            }).then((resp) => {
                WorkerServices.setAudienceCache([cat, resp])
                finalObj[cat.path] = resp;
                return resp;
            })
        })).then(() => (finalObj));
    }

    async getCategoryAudienceSizeV2(categories) {
        const { server } = getServer();
        const region = getCountryCode("savant");
        const options = {
            gateway: {
                class: this.cls,
                function: "sspgetaudiencesize"
            }
        };

        const getSSPAudienceSize = (requestBody) => MainServices.smartApiCall(
            options,
            {
                ...requestBody,
                _class: "oneintel",
                _function: "sspgetaudiencesize",
            }
        ).promise
        // MainServices.savantApiCall(
        //     options.gateway.function,
        //     {
        //         ...requestBody,
        //         _class: "oneintel",
        //         _function: "sspgetaudiencesize",
        //     },
        //     options,
        //     server,
        //     MainServices.url + "oneintel/" + options.gateway.function.toLocaleLowerCase()
        // ).promise;

        const getAudiencePerCategory = (category) => {
            const folderList = {};

            const recursiveGetFolderAndKeywords = (list) => {
                if (!list) return;
                list.forEach((item) => {
                    const keyword = item.name.toLocaleLowerCase();
                    const childList = item.children || item.tempChildren;
                    folderList[item.path] = childList?.length ? getAllKeywordsInFolder(childList, []) : [keyword];
                    recursiveGetFolderAndKeywords(item.children);
                });
            };
            recursiveGetFolderAndKeywords([category]);
            const audienceItems = Object.values(folderList)[0].map((text) => {
                const newText = text.split(" ").join(" ")
                return newText
            })

            if (audienceItems.length === 1) audienceItems.push("the heck")
            return getSSPAudienceSize({
                region,
                type: "keyword",
                items: audienceItems,
                server
            }).then((resp) => {
                const { data } = resp || {};
                if (!data) { return {}; }
                const audienceList = Object.keys(folderList).reduce((acc, path) => {
                    acc[path] = 0;
                    Object.keys(resp.data).forEach((key) => {
                        if (folderList[path].includes(key)) {
                            acc[path] += resp.data[key];
                        }
                    });
                    return acc;
                }, {});
                return audienceList;
            });
        };

        let finalObj = {};
        return Promise.all(categories.map((cat) => getAudiencePerCategory(cat).then((resp) => {
            finalObj = { ...finalObj, ...resp };
            return resp;
        }))).then(() => (finalObj));
    }

    getGeneratedGridSegments(items) {
        const { server } = getServer();
        const region = getCountryCode("savant");
        const options = {
            gateway: {
                class: this.cls,
                function: "sspgetaudiencesize"
            }
        };

        const getSSPAudienceSize = (requestBody) => MainServices.smartApiCall(
            options,
            {
                ...requestBody,
                _class: "oneintel",
                _function: "sspgetaudiencesize",
            }
        ).promise


        // MainServices.savantApiCall(
        //     options.gateway.function,
        //     {
        //         ...requestBody,
        //         _class: "oneintel",
        //         _function: "sspgetaudiencesize",
        //     },
        //     options,
        //     server,
        //     MainServices.url + "oneintel/" + options.gateway.function.toLocaleLowerCase()
        // ).promise;
        const audienceItems = items.map((item) => {
            let newText = item.name.toLocaleLowerCase()
            if (item.name.split(" - ").length > 1) {
                newText = item.name.split(" - ")[1].trim().toLocaleLowerCase();
            }
            return newText.split(" ").join(" ")
        })
        if (audienceItems.length === 1) audienceItems.push("the heck")
        return getSSPAudienceSize({
            region,
            type: "keyword",
            items: audienceItems,
            server
        }).then((resp) => {
            const { data } = resp || {};
            if (!data) { return {}; }
            return resp.data;
        });
    }

    async getNewNameAfterWordRemoved(catName) {
        const configObj = await ConfigServices.getWhiteSpaceConfig();
        const newName = catName;
        const findToRemove = (configObj?.wordsToRemove || []).find((text) => catName.includes(text));
        if (findToRemove) {
            return Promise.resolve(newName.replace(findToRemove, "").trim().replace(/ {2}/g, " "));
        }
        return Promise.resolve(catName);
    }

    async getOverAllPieChart(category) {
        const state = getState();
        const {
            marketPackage
        } = state.buildTargets.setup;
        const { code: packageCode } = getPackageObj();
        const { url, server } = getServer();
        const configObj = await ConfigServices.getWhiteSpaceConfig();
        // TM = treatment and medication
        const ifNeedToAddTM = async (name) => {
            if (configObj?.exemptedCategory.includes(name)) return false;
            const newName = await this.getNewNameAfterWordRemoved(name);
            return Promise.resolve([
                newName,
                `${newName} treatment`,
                `${newName} medication`
            ]);
        };

        const categoryName = cleanString(category.name).toLocaleLowerCase();
        let highest = categoryName;
        if (["healthcarewhitespaces", "veterinaryjourney"].includes(packageCode.replace("dev", ""))) {
            let items = await ifNeedToAddTM(categoryName);
            const translated = await this.getWhiteSpaceToTranslate(category.name);
            if (translated) {
                if (!items) items = [];
                items.push(translated.name);
                highest = translated.name;
            } else {
                if (items) {
                    const options = {
                        gateway: {
                            class: this.cls,
                            function: "listrelationships"
                        }
                    };
                    highest = await MainServices.smartApiCall(
                        options,
                        {
                            type: "keyword",
                            region: getCountryCode("savant"),
                            limit: 1000,
                            tangentalThreshold: 0.2,
                            distantThreshold: 0.1,
                            precision: 0,
                            topic: "",
                            server,
                            items
                        },
                        () => { }
                    ).promise.then((resp) => {
                        if (!resp) return null;
                        if (resp?.countryloading) {
                            return null;
                        }
                        if (resp?.status === "ERROR") {
                            console.log(resp);
                            return null;
                        }
                        const list = Object.keys(resp.data).reduce((acc, key) => {
                            if (key !== categoryName && key !== items[0]) {
                                acc.push({
                                    name: key,
                                    itemCount: resp.data[key][1]
                                });
                            }
                            return acc;
                        }, []);
                        const highestScore = Math.max(...list.map((d) => d.itemCount));
                        return list.find((d) => highestScore === d.itemCount);
                    });
                    if (highest) {
                        highest = highest.name;
                    }
                }
            }
        }

        const {
            brands,
            brands2ndChild,
            brandsOrigTextLower
        } = getBrandGenericsHcp();

        const processToGetPieResult = async (brandList) => {
            const getRelationsips = async () => {
                const options = {
                    gateway: {
                        class: this.cls,
                        function: "listrelationships"
                    }
                };

                const { promise } = MainServices.smartApiCall(
                    options,
                    {
                        type: "keyword",
                        region: getCountryCode("savant"),
                        limit: 1000,
                        tangentalThreshold: 0.2,
                        distantThreshold: 0.1,
                        precision: 0,
                        topic: highest,
                        server,
                        items: [
                            highest,
                            ...Object.values(brandList).reduce((acc, arr) => {
                                arr.forEach((i) => {
                                    const nKw = i.variants || i.key;
                                    if (!acc.includes(nKw)) acc.push(nKw);
                                });
                                return acc;
                            }, [])
                        ].map((text) => getTranslation(cleanString(text)))
                    },
                    () => { }
                );
                return promise.then((resp) => {
                    if (!resp) return [];
                    if (resp?.countryloading) {
                        return resp;
                    }
                    if (resp?.status === "ERROR") {
                        console.log(resp);
                        return null;
                    }
                    let hasZero = false;
                    let relList = Object.keys(resp.data).reduce((acc, key) => {
                        if (key !== highest) {
                            const relScore = resp.data[key][2];
                            acc[key] = ({
                                name: key,
                                itemCount: resp.data[key][1],
                                relationshipCount: relScore
                            });
                            if (!relScore) hasZero = true;
                        }
                        return acc;
                    }, {});
                    const safeGuard = (list) => {
                        if (!hasZero) return list;
                        const ranksObj = {};
                        Object.values(list).filter((item) => !item.relationshipCount)
                            .sort(dynamicSort("itemCount", true)).forEach((item, idx) => {
                                ranksObj[item.name] = idx + 1;
                            });
                        const max = Math.max(...Object.values(ranksObj));
                        return Object.values(list).reduce((acc, item) => {
                            if (item.relationshipCount) {
                                acc[item.name] = {
                                    ...item,
                                    relationshipCount: item.relationshipCount + max
                                };
                            } else {
                                acc[item.name] = {
                                    ...item,
                                    relationshipCount: ranksObj[item.name]
                                };
                            }
                            return acc;
                        }, {});
                    };
                    relList = safeGuard(relList);
                    return relList;
                });
            };
            const relationlist = await getRelationsips();

            const { list: listwithscore, sum: sumScoreBrands } = Object.values(brandList).reduce((acc, arr) => {
                arr.forEach((d) => {
                    const brandName = getTranslation(cleanString(d.variants || d.key));
                    let relationObj = relationlist[brandName];
                    if (!relationObj) {
                        relationObj = relationlist[brandName.replace(/[`']/g, "")];
                    }
                    const obj = {
                        title: d.name,
                        name: relationObj.name,
                        relationScore: relationObj.relationshipCount
                    };
                    acc.sum += obj.relationScore;
                    acc.list.push(obj);
                });
                return acc;
            }, {
                list: [], sum: 0
            });

            const newList = Object.values(listwithscore.map((d) => {
                const tempObj = { ...d };
                tempObj.score = (d.relationScore / sumScoreBrands) * 100;
                if (isNaN(tempObj.score)) tempObj.score = 0;
                return tempObj;
            }).reduce((acc, d) => {
                if (!acc[d.title]) {
                    acc[d.title] = d;
                } else {
                    acc[d.title].score += d.score;
                }
                return acc;
            }, {}));
            return Promise.resolve(newList.sort(dynamicSort("-score", true)));
        };

        let result = await processToGetPieResult(brands);
        if ((["jpn"].includes(getCountryCode("enterprise")) || marketPackage?.code?.replace("dev", "") === "healthcareclaims")
            && Object.keys(brands2ndChild).length) {
            const checker = Object.keys(brands2ndChild).reduce((acc, key) => {
                acc[key] = brands2ndChild[key].map((obj) => obj.name);
                return acc;
            }, {});
            result = result.reduce((acc, item) => {
                const foundParent = Object.keys(checker).find((key) => checker[key].includes(item.title));
                if (foundParent) {
                    const parentObj = brandsOrigTextLower[foundParent];
                    if (parentObj) {
                        if (!acc[parentObj.name]) {
                            acc[parentObj.name] = {
                                title: parentObj.name,
                                name: parentObj.name,
                                score: item.score
                            };
                        } else {
                            acc[parentObj.name].score += item.score;
                        }
                    }
                }
                return acc;
            }, {});
            result = Object.values(result).sort(dynamicSort("-score", true));
        }

        return Promise.resolve(result);
    }

    getGeneratedText(items) {
        const { promise, resolve } = createPromise();
        const region = getCountryCode("savant");
        const { url } = OneIntelligenceServices.getSavantCountryObj(region);
        const newItems = items.map((d) => d.toLocaleLowerCase());
        const path = `${newItems.join("/")}.txt`;
        MainServices.sqsSendMessage("https://sqs.ap-southeast-1.amazonaws.com/788016873502/OneIntelligence-Context", JSON.stringify({
            id: path,
            region,
            savantUrl: url,
            items: newItems

        })).then(() => {
            const getText = () => {
                setTimeout(() => MainServices.getFile(
                    path,
                    "context"
                ).then((resp) => {
                    if (resp) {
                        resolve(resp);
                    } else {
                        getText();
                    }
                }), 1000);
            };
            getText();
        });

        return promise;
    }

    async getWhiteSpaceToTranslate(catName) {
        const list = await ConfigServices.getWhiteSpaceTranslation();
        const state = getState();
        const { country } = state.buildTargets.setup;
        const { url, server } = getServer();

        const newCatName = cleanString(catName).toLocaleLowerCase();
        const found = list.find((d) => d.country === country.name);
        if (found) {
            if (found.language !== "English") {
                let tree = await TreeServices.getWhiteSpaceTree(undefined, { folder: "B - Generics.folder" });
                tree = await WorkerServices.getRelatedByFolders([[catName.split(" ")[0].toLocaleLowerCase()],
                [...tree], true]);
                if (tree.length) {
                    const keywords = [];
                    const recursiveGetFolderAndKeywords = (treeList) => {
                        if (!treeList) return;
                        treeList.forEach((item) => {
                            const childList = item.children || item.tempChildren;
                            getAllKeywordsInFolderObject(childList, keywords);
                            recursiveGetFolderAndKeywords(childList);
                        });
                    };
                    if (tree.length > 1) {
                        const tempTree = tree.filter((t) => t.name.trim() === catName.trim());
                        if (tempTree?.length) {
                            tree = tempTree;
                        }
                    }
                    recursiveGetFolderAndKeywords(tree);
                    const options = {
                        gateway: {
                            class: this.cls,
                            function: "listrelationships"
                        }
                    };


                    const getWithHightItemCount = () => MainServices.smartApiCall(
                        options,
                        {
                            type: "keyword",
                            region: getCountryCode("savant"),
                            limit: 1000,
                            tangentalThreshold: 0.2,
                            distantThreshold: 0.1,
                            precision: 0,
                            topic: "",
                            server,
                            items: [...keywords.map((d) => cleanString(d.variants || d.key))]
                        },
                        () => { }
                    ).promise.then((resp) => {
                        if (!resp) return [];
                        if (resp?.countryloading) {
                            return resp;
                        }
                        if (resp?.status === "ERROR") {
                            console.log(resp);
                            return null;
                        }
                        const respList = Object.keys(resp.data).reduce((acc, key) => {
                            if (key !== newCatName) {
                                acc.push({
                                    name: key,
                                    itemCount: resp.data[key][1]
                                });
                            }
                            return acc;
                        }, []);
                        const highestScore = Math.max(...respList.map((d) => d.itemCount));
                        return respList.find((d) => highestScore === d.itemCount);
                    });
                    const hightest = await getWithHightItemCount();
                    return Promise.resolve(hightest);
                }
            }
        }
        return Promise.resolve(false);
    }
}

export default new WhiteSpaceServices();
